import { useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";

export const ImageUpload = ({ value, onChange, testId = "image-upload", label = "Ajouter une image", tall = false }) => {
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    const fd = new FormData();
    fd.append("file", f);
    setBusy(true);
    try {
      const { data } = await api.post("/upload", fd);
      onChange(data.path);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`relative rounded-xl border-2 border-dashed border-emerald-900/15 bg-emerald-50/40 overflow-hidden ${tall ? "h-40 w-32" : "h-40 w-full"}`}>
      {value ? (
        <>
          <img src={fileUrl(value)} alt="Aperçu" className="h-full w-full object-cover" />
          <button type="button" data-testid={`${testId}-remove`} onClick={() => onChange(null)} className="absolute top-2 right-2 rounded-full bg-white/90 p-1 hover:bg-white">
            <X className="h-4 w-4" />
          </button>
        </>
      ) : (
        <label className="h-full w-full grid place-items-center cursor-pointer text-center text-xs text-slate-500 p-2 hover:bg-emerald-50 transition-colors">
          {busy ? <Loader2 className="h-6 w-6 animate-spin text-emerald-700" /> : <span className="flex flex-col items-center gap-1"><ImagePlus className="h-6 w-6 text-emerald-700" />{label}</span>}
          <input data-testid={testId} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={pick} disabled={busy} />
        </label>
      )}
    </div>
  );
};
